export const EXSBOPERATION_SHOW_RESET = 'EXSBOPERATION_SHOW_RESET'
export const EXSBOPERATION_SHOW_SET_ERROR = 'EXSBOPERATION_SHOW_SET_ERROR'
export const EXSBOPERATION_SHOW_SET_RETRIEVED = 'EXSBOPERATION_SHOW_SET_RETRIEVED'
export const EXSBOPERATION_SHOW_TOGGLE_LOADING = 'EXSBOPERATION_SHOW_TOGGLE_LOADING'
